import { render, staticRenderFns } from "./Divide.vue?vue&type=template&id=493a71a0"
import script from "./Divide.vue?vue&type=script&lang=js"
export * from "./Divide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports